// extracted by mini-css-extract-plugin
export default {"p":"_3c61ab2cb8 _29d7fe7632 _9e21ec4936","clr":"_45d568bae0","dls":"d21ffb4bac"};